<template>
  <Modal :title="title" :loading="true" v-model="modalVisible" :mask-closable="false">
    <div class="bd">
      <table></table>
    </div>
    <div slot="footer">
      <Button :loading="loading" @click="save()" type="primary">推送签约消息</Button>
    </div>
  </Modal>
</template>
<script>
  export default {
    data() {
      return {
        modalVisible:false,
        loading:false,
        id:null,
        data:{}
      }
    },

    created(){

    },
    computed:{
      title(){
        return "订单签约"
      },
      buttonTitle(){
        return ( this.data.flowState == 3 || this.data.flowState == 4 ) ? '重新推送签约消息' : '推送签约消息'
      }
    },

    mounted() {},

    methods: {
      init(data) {
        this.data = data
        this.id = data.id

        if(this.id){
          this.modalVisible = true
          this.$request.contractByOrder( this.id ).then(resp=>{
            console.log(resp)
          })
        }
      },

      save() {
      this.loading = true
      this.$request.orderSign({id:this.id}).then(resp => {
        if (resp.code) {
          this.$Message.error({ content: resp.msg })
        } else {
          this.$Message.success('操作成功')
          this.$emit('on-update')
          this.modalVisible = false
          // this.$keepAlive.update()
        }
        this.loading = false
      })

    },

    handleChange(v){
      console.log(v , this.form)
    }
  }
}
</script>